module.exports = "/static-assets/_next/static/images/Poloaroid-1-59bd91e51055ae35547536e5695940e6.png";